<div class="titolo-dialog">
  <h2 mat-dialog-title style="font-size: 25px">Impatti Tema</h2>
</div>

<div mat-dialog-content class="dialog-center-cont">
  <div style="height: 10px"></div>

  <!-- ---------------------------------------- I M P A T T I ------------------------- -->
  <div class="cont-dd" appFormContainer [larghezza]="2">
    <div appFormElement [larghezza]="1" [riempi]="true" class="list-container">
      <div class="cont-titolo">
        <mat-label class="titolo">Impatti Selezionate</mat-label>
        <div>
          <button
            mat-flat-button
            class="imp-esclud"
            color="accent"
            (click)="apriFiltroSelezionati('impatti')"
            matBadgeColor="warn"
          >
            <mat-icon matSuffix>filter_list</mat-icon>
            Filtri
          </button>
        </div>
      </div>
      <ng-scrollbar #scrollSelezionate>
        <div
          scrollViewport
          dropListScroller
          cdkDropList
          #selListImpatti="cdkDropList"
          [cdkDropListData]="arrayImpattiSel"
          [cdkDropListConnectedTo]="[dispListImpatti]"
          class="list"
          (cdkDropListDropped)="dropImpatti($event)"
        >
          <div class="nessun-elemento" *ngIf="!arrayImpattiSel?.length && !loadingDisponibili">
            <p>Nessun impatto selezionato</p>
          </div>

          <div
            class="box"
            *ngFor="let sel of arrayImpattiSelFiltrati"
            cdkDrag
            [matTooltip]="sel.descrizione"
          >
            <div class="box-sx">
              <button mat-icon-button title="Sposta" aria-label="Sposta">
                <mat-icon> drag_handle </mat-icon>
              </button>
              <mat-label class="truncate">{{ sel.titolo }}</mat-label>
            </div>
          </div>
        </div>
      </ng-scrollbar>
    </div>
    <div appFormElement [larghezza]="1" [riempi]="true" class="list-container">
      <div class="cont-titolo">
        <mat-label class="titolo">Impatti Disponibili</mat-label>
        <div>
          <button
            mat-flat-button
            class="imp-esclud"
            color="accent"
            (click)="apriFiltro('impatti')"
            matBadgeColor="warn"
          >
            <mat-icon matSuffix>filter_list</mat-icon>
            Filtri
          </button>
        </div>
      </div>
      <ng-scrollbar #scrollDisponibili>
        <div
          cdkDropList
          scrollViewport
          dropListScroller
          #dispListImpatti="cdkDropList"
          [cdkDropListData]="arrayImpattiDisponibili"
          [cdkDropListConnectedTo]="[selListImpatti]"
          class="list"
          style="background-color: #f5f5f5"
          (cdkDropListDropped)="dropImpatti($event)"
        >
          <div class="elemento-disp" *ngIf="loadingDisponibili">
            <mat-spinner style="height: 50px"></mat-spinner>
          </div>

          <div
            class="nessun-elemento"
            *ngIf="!arrayImpattiDisponibili?.length && !loadingDisponibili"
          >
            <p>Nessun impatto disponibile</p>
          </div>

          <div
            class="box"
            style="background-color: #f5f5f5"
            *ngFor="let disp of arrayImpattiDisponibili"
            cdkDrag
            [matTooltip]="disp.descrizione"
          >
            <div class="box-sx">
              <button mat-icon-button title="Sposta" aria-label="Sposta">
                <mat-icon> drag_handle </mat-icon>
              </button>
              <mat-label class="truncate">{{ disp.titolo }}</mat-label>
            </div>
          </div>
        </div>
      </ng-scrollbar>
    </div>
  </div>
</div>
<div mat-dialog-actions class="dialog-footer-cont">
  <div>
    <button mat-dialog-close mat-flat-button color="accent" class="accent-button">Chiudi</button>
  </div>
  <div>
    <button mat-flat-button color="primary" (click)="salva()" class="primary-button">Salva</button>
  </div>
</div>
